import { useState } from 'react';
import { ReactComponent as InfoIcon } from '../Icons/Info.svg';
import ColorScheme from '../ColorScheme/ColorScheme';
import Themes from '../Themes';

const Info = ({ tooltipInfo, theme, size = '16px', className = '' }) => {
    const [hover, setHover] = useState();
    const [focus, setFocus] = useState();

    const calculateColor = () => {
        if (focus) return ColorScheme['sf-primary-200'];
        if (hover) return ColorScheme['sf-gray-400'];

        return Themes[theme] === Themes.Dark ? ColorScheme['sf-gray-500'] : ColorScheme['sf-gray-300'];
    };
    return (
        //TODO: implement tooltip
        <InfoIcon
            className={`cursor-pointer ${className}`}
            style={{ width: size, height: size }}
            onMouseDown={() => setFocus(true)}
            onMouseUp={() => setFocus(false)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            fill={calculateColor()}
        />
    );
};

export default Info;
